import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener, OnChanges,
  OnInit,
  Output,
  Renderer2, SimpleChanges,
  ViewChild,
} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DxButtonComponent} from 'devextreme-angular';
import {DxButtonGroupComponent} from 'devextreme-angular';
import config from 'devextreme/core/config';
import DataSource from 'devextreme/data/data_source';
import {dxDataGridColumn} from 'devextreme/ui/data_grid';
import {custom} from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import repaintFloatingActionButton from 'devextreme/ui/speed_dial_action/repaint_floating_action_button';
import ValidationEngine from 'devextreme/ui/validation_engine';
import {CREATED} from 'http-status-codes';
import {startCase} from 'lodash';
import * as Moment from 'moment-timezone';
import {BehaviorSubject, forkJoin, Observable, of} from 'rxjs';
import {switchMap, take} from 'rxjs/operators';
import {ReportsService} from 'src/app/modules/shared/services/reports.service';
import {environment} from '../../../../../../environments/environment';
import {RegistrationRequest} from '../../../../../shared/models/fusion-auth';
import {FusionAuthManagementService, FusionAuthService} from '../../../../../shared/services/fusion-auth';
import {PWADetectorService, ScreenService} from '../../../../../shared/services/general';
import {RecentRequisitionService} from '../../../../../shared/services/ocl';
import {DirtyComponent, FileUtils, TestUtils} from '../../../../../shared/utils';
import {BillTo} from '../../../../shared/models/billing/bill-type';
import {BillingInformation} from '../../../../shared/models/billing/billing-information';
import {Document} from '../../../../shared/models/common/document';
import {PatientEditable} from '../../../../shared/models/order-entry/patient';
import {DiagnosisService, MedicationService, PatientService} from '../../../../shared/services';
import {RequisitionService} from '../../../../shared/services/requisition.service';
import {TestService} from '../../../../shared/services/test.service';
import {SignatureRepresentation} from '../../components/signature-dialog/signature-dialog.component';
import {ClinicalInfo, Requisition} from '../../models/requisition';
import {RequisitionBillingInfo} from '../../models/requisition-billing-infog';
import {RequisitionStatus} from '../../models/requisition-search';
import {MultipleRequisitionsSignature, RequisitionSignature, Signature} from '../../models/signature';
import {RecentRequisitionViewModel} from "../../../../../shared/models/ocl";

@Component({
  selector: 'app-requisition-create',
  templateUrl: './requisition-create.component.html',
  styleUrls: ['./requisition-create.component.scss'],
})
export class RequisitionCreateComponent implements OnInit, AfterViewInit, DirtyComponent {
  @ViewChild('unsignBtn', {static: false}) public unsignBtn?: DxButtonComponent;
  @ViewChild('signBtn', {static: false}) public signBtn?: DxButtonComponent;
  @ViewChild(DxButtonGroupComponent, {static: false}) public buttonGroup?: DxButtonGroupComponent;

  @Output() public selectedPatientChange = new EventEmitter();

  public requisitionCreateForm: FormGroup;
  public electronicSignaturePopupVisible = false;
  public electronicSignatureUnsignPopupVisible = false;
  public cancelPopupVisible = false;
  public clinicalInfo = [{value: ClinicalInfo.Unknown, text: 'UNKNOWN'}, {
    value: ClinicalInfo.Fasting,
    text: 'FASTING',
  }, {value: ClinicalInfo.NonFasting, text: 'NON FASTING'}];
  public priorities = ['STAT', 'ROUTINE', 'RUSH', 'PRE-OPERATORY'];
  public isLoading = false;
  public selectedBillToOnlyForEdit: any[] = [];
  public selectedDefaultBillToOnlyForEdit: string = BillTo[BillTo.Insurance].toUpperCase();
  public printerDialogVisible = false;
  public docs: Document[] = [];
  public requisitionId = -1;
  public isUploading = false;
  public requisitionDoneVisible = false;
  public mode: 'create' | 'update' = 'create';
  // @ts-ignore
  public diagnosisDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
  // @ts-ignore
  public alternateDiagnosisDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
  // @ts-ignore
  public medicationsDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
  // @ts-ignore
  public alternateMedicationsDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
  public diagnosesFormRelationColumns: Array<dxDataGridColumn | string> = [
    {
      dataField: 'code',
      width: 100,
      caption: 'Code',
      allowFiltering: true,
      allowSorting: true,
      allowResizing: true,
    } as dxDataGridColumn,
    {
      dataField: 'shortName',
      caption: 'Name',
      allowFiltering: true,
      allowSorting: true,
      allowResizing: true,
    } as dxDataGridColumn,
  ];
  public medicationsFormRelationColumns: Array<dxDataGridColumn | string> = [
    {
      dataField: 'code',
      width: 100,
      caption: 'Code',
      allowFiltering: true,
      allowSorting: true,
      allowResizing: true,
    } as dxDataGridColumn,
    {
      dataField: 'name',
      caption: 'Name',
      allowFiltering: true,
      allowSorting: true,
      allowResizing: true,
    } as dxDataGridColumn,
  ];
  public showAllTestsInPicker: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public selectedClient: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  // @ts-ignore
  public testPickerDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);

  public moreOptions: any;
  public saveButtonOptions: any;
  public cancelButtonOptions: any;
  public clearButtonOptions: any;
  public isPhoneOrTablet: boolean = false;
  public isPhone: boolean = false;
  public canNavigate = false;
  public isReadOnly = false;
  public role: string = '';

  public onDestroy$: BehaviorSubject<null> = new BehaviorSubject(null);

  constructor(
    private fb: FormBuilder,
    private pwaDetectorService: PWADetectorService,
    public medicationService: MedicationService,
    public diagnosisService: DiagnosisService,
    public fusionAuthService: FusionAuthService,
    public requisitionService: RequisitionService,
    public patientService: PatientService,
    public router: Router,
    public route: ActivatedRoute,
    public reportsService: ReportsService,
    public recentRequisitionService: RecentRequisitionService,
    private renderer: Renderer2,
    private fusionAuthManagement: FusionAuthManagementService,
    private screen: ScreenService,
    private testService: TestService,
    private ref: ChangeDetectorRef,
  ) {
    this.requisitionCreateForm = this.fb.group({
      id: [null],
      code: [null],
      patient: [null, [Validators.required]],
      collectionDate: [null, [Validators.required]],
      fasting: [ClinicalInfo.Unknown, [Validators.required]],
      priority: ['ROUTINE', [Validators.required]],
      physician: [null],
      status: [null],
      tests: [null, [Validators.required]],
      additionalTestsDxCodes: [null],
      diagnosisCodes: [[]],
      medications: [[]],
      billTo: [null],
      billingInformation: [null],
      signature: [null],
      comments: [null],
      additionalCopies: [[]],
    });
    this.moreOptions = [
      {
        icon: 'fa fa-barcode',
        text: 'Labels',
        hint: 'Print Requisition Labels',
        disabled: true,
      },
      {
        icon: 'fa fa-print',
        text: 'Print',
        hint: 'Print Requisition',
        disabled: true,
      },
    ];

    this.saveButtonOptions = {
      text: 'Save',
      disabled: this.IsNotEditable,
      onClick: () => {
        this.openUnsignDialog();
      },
    };

    this.cancelButtonOptions = {
      text: 'Cancel',
      disabled: !this.IsRequisitionCancelable || this.IsNotEditable,
      onClick: () => {
        this.openCancelRequisitionDialog();
      },
    };

    this.clearButtonOptions = {
      text: 'Clear',
      onClick: () => {
        this.clear();
      },
    };

    this.requisitionCreateForm.valueChanges
      .subscribe(formData => {
        if (formData.id) {
          this.moreOptions = [
            {
              icon: 'fa fa-barcode',
              text: 'Labels',
              hint: 'Print Requisition Labels',
              disabled: false,
            },
            {
              icon: 'fa fa-print',
              text: 'Print',
              hint: 'Print Requisition',
              disabled: false,
            },
            {
              icon: 'fa fa-pen-alt',
              text: formData.signature === null ? 'Sign' : 'Unsign',
              hint: formData.signature === null ? 'Sign Requisition' : 'Unsign Requisition',
              disabled: this.isReadOnly,
            },
          ];
        } else {
          this.moreOptions = [
            {
              icon: 'fa fa-barcode',
              text: 'Labels',
              hint: 'Print Requisition Labels',
              disabled: true,
            },
            {
              icon: 'fa fa-print',
              text: 'Print',
              hint: 'Print Requisition',
              disabled: true,
            }, /*,
            {
              icon: 'fa fa-pen-alt',
              text: 'Sign',
              hint: 'Sign Requisition',
              disabled: true,
            },*/
          ];
        }
      });
  }

  public ngOnInit(): void {
    this.initResponsive();
    this.diagnosisDataSource.next(new DataSource({store: this.diagnosisService.customStore(this.diagnosisDataSource)}));
    this.medicationsDataSource.next(new DataSource({store: this.medicationService.customStore(this.medicationsDataSource)}));
    this.testPickerDataSource.next(new DataSource({
      store: this.testService.customStore(this.testPickerDataSource, this.selectedClient.value, this.showAllTestsInPicker.value),
    }));
    this.isLoading = true;

    const request = this.route.paramMap.pipe(
      switchMap(params => {
        if (params.get('id')) {
          // @ts-ignore
          this.requisitionId = +params.get('id');
          this.isLoading = true;
          this.mode = 'update';
          return forkJoin([
            this.requisitionService.getRequisition(this.requisitionId),
            this.requisitionService.getRequisitionBillingInformation(this.requisitionId),
            this.requisitionService.getRequisitionSignature(this.requisitionId),
          ]);
        } else {
          const currentDate = new Date();
          currentDate.setHours(0);
          currentDate.setMinutes(0);
          currentDate.setSeconds(0);
          this.requisitionCreateForm.get('collectionDate')?.setValue(currentDate);
          return forkJoin([of(null), of(null), of(null)]);
        }
      }),
    );

    request.pipe(take(1))
      // @ts-ignore
      .subscribe(([requisition, billingInfo, signature]: [Requisition, RequisitionBillingInfo[], RequisitionSignature]) => {
        if (!requisition) {
          this.isLoading = false;
          return;
        }

        this.isReadOnly = requisition.status === RequisitionStatus.Canceled || requisition.status === RequisitionStatus.Done;
        switch (requisition.billTo) {
          case BillTo.Client:
            this.selectedDefaultBillToOnlyForEdit = BillTo[BillTo.Client].toUpperCase();
            break;
          case BillTo.Patient:
            this.selectedDefaultBillToOnlyForEdit = BillTo[BillTo.Patient].toUpperCase();
            break;
          default:
            this.selectedDefaultBillToOnlyForEdit = BillTo[BillTo.Insurance].toUpperCase();
            break;
        }
        if (billingInfo) {
          billingInfo.forEach(b => b.position = b.position + 1);
          this.selectedBillToOnlyForEdit = billingInfo;
        }

        this.requisitionCreateForm.get('id')?.setValue(requisition.id);
        this.requisitionCreateForm.get('code')?.setValue(requisition.code);
        this.requisitionCreateForm.get('patient')?.setValue(requisition.patient);
        this.requisitionCreateForm.get('additionalCopies')?.setValue(requisition.additionalCopies);
        this.requisitionCreateForm.get('collectionDate')?.setValue(Moment(requisition.collectionDate));
        this.requisitionCreateForm.get('priority')?.setValue(requisition.priority);
        this.requisitionCreateForm.get('physician')?.setValue(requisition.physician);
        this.requisitionCreateForm.get('tests')?.setValue(requisition.treeTests);
        this.requisitionCreateForm.get('additionalTestsDxCodes')?.setValue(requisition.additionalTestsDxCodes);
        this.requisitionCreateForm.get('status')?.setValue(requisition.status);
        this.requisitionCreateForm.get('diagnosisCodes')?.setValue(requisition.diagnoses);
        this.requisitionCreateForm.get('medications')?.setValue(requisition.medications);
        // @ts-ignore
        this.requisitionCreateForm.get('billTo')?.setValue(BillTo[requisition.billTo]);
        this.requisitionCreateForm.get('billingInformation')?.setValue(billingInfo);
        this.requisitionCreateForm.get('comments')?.setValue(requisition.comments);
        this.requisitionCreateForm.get('fasting')?.setValue(requisition.fasting === ClinicalInfo.NonFasting
          ? this.clinicalInfo[2].value
          : requisition.fasting);

        this.requisitionService.getRequisitionDocuments(this.requisitionId).pipe(take(1)).subscribe(docs => this.docs = docs);

        if (signature) {
          if (!signature.signature) {
            signature.signature = new Signature();
          }

          if (!signature.signature.imageSignature) {
            signature.signature.imageSignature = '';
          }
          this.requisitionCreateForm.get('signature')?.setValue(signature);
          if (this.signBtn && this.unsignBtn) {
            this.signBtn.disabled = true;
            this.unsignBtn.disabled =
              this.requisitionCreateForm.get('signature')?.value.signature.userName ===
              `${this.fusionAuthService.Profile.firstName} ${this.fusionAuthService.Profile.lastName}`;
          }
        }

        this.isLoading = false;
        this.ref.detectChanges();
      });

    this.waitByUser();
  }

  public ngAfterViewInit(): void {
    if (this.signBtn && this.unsignBtn) {
      this.signBtn.disabled = false;
      this.unsignBtn.disabled = true;
    }

    this.selectedClient
      .subscribe(clientId => this.testPickerDataSource.next(new DataSource({
        store: this.testService.customStore(this.testPickerDataSource, clientId, this.showAllTestsInPicker.value),
      })));

    this.showAllTestsInPicker
      .subscribe(allTests => this.testPickerDataSource.next(new DataSource({
        store: this.testService.customStore(this.testPickerDataSource, this.selectedClient.value, allTests),
      })));
  }

  public initResponsive() {
    const configureResponsive = () => {
      this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
      this.isPhone = this.screen.sizes['screen-x-small'];

      const offset = this.isPhone ? '-15 75' : '-25 75';
      config({
        floatingActionButtonConfig: {
          icon: 'rowfield',
          shading: true,
          direction: 'down',
          position: {
            of: 'body',
            my: 'right top',
            at: 'right top',
            offset,
          },
        },
      });
      repaintFloatingActionButton();
    };
    configureResponsive();
    this.screen.changed.subscribe(() => {
      configureResponsive();
    });
  }

  public get IsNotEditable() {
    return this.requisitionCreateForm.get('status')?.value
      ? this.requisitionCreateForm.get('status')?.value === RequisitionStatus.Canceled
      : false;
  }

  public get IsPatientSelected() {
    return this.requisitionCreateForm.get('patient')?.value !== null;
  }

  public openSignDialog() {
    this.electronicSignaturePopupVisible = true;
  }

  public openCancelRequisitionDialog() {
    if (this.IsRequisitionCancelable) {
      this.cancelPopupVisible = true;
    }
  }

  public cancelRequisitionDialogClosed(response: { comment: string }) {
    if (response && response.comment) {
      this.isLoading = true;
      this.requisitionService
        .cancelRequisition(this.requisitionCreateForm.get('id')?.value, response.comment)
        .pipe(take(1))
        .subscribe(() => {
          notify('Requisition canceled', 'success');
          this.requisitionCreateForm.get('status')?.setValue(RequisitionStatus.Canceled);
          this.isReadOnly = true;
          this.isLoading = false;
          this.cancelPopupVisible = false;
        });
    } else {
      this.cancelPopupVisible = false;
    }
  }

  public billToChanged(billTo: string) {
    this.requisitionCreateForm.get('billTo')?.setValue(billTo);
  }

  public get IsRequisitionCancelable() {
    return (
      this.requisitionCreateForm.get('id')?.value !== undefined &&
      this.requisitionCreateForm.get('id')?.value !== null &&
      this.requisitionCreateForm.get('id')?.value !== -1 &&
      this.requisitionCreateForm.get('id')?.value !== 0
    );
  }

  public openSignatureDialog() {
    if (!this.signBtn?.disabled) {
      this.openSignDialog();
    } else {
      this.openUnsignDialog();
    }
  }

  public waitByUser() {
    const user = this.fusionAuthService.Profile;
    if (user) {
      this.role = user.registrations[0].roles[0];
    } else {
      setTimeout(() => {
        this.waitByUser();
      }, 1000);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  // @ts-ignore
  public beforeUnloadHandler(event: any) {
    if (!this.canNavigate && this.requisitionCreateForm.dirty) {
      const returnValue = 'There are unsaved changes. Do you want to continue and lose these changes?';
      event.returnValue = returnValue;
      return returnValue;
    }
  }

  public canDeactivate() {
    return this.canNavigate ? false : this.requisitionCreateForm.dirty;
  }

  public get Status() {
    let color;
    let status = '';
    switch (this.requisitionCreateForm.get('status')?.value) {
      case RequisitionStatus.Canceled:
        color = 'ocl-status-black';
        status = RequisitionStatus[RequisitionStatus.Canceled];
        break;
      case RequisitionStatus.Done:
        color = 'ocl-status-green';
        status = RequisitionStatus[RequisitionStatus.Done];
        break;
      case RequisitionStatus.Pending:
        color = 'ocl-status-yellow';
        status = RequisitionStatus[RequisitionStatus.Pending];
        break;
    }

    return `<div fxLayout='column' fxLayoutAlign='center'>
                    <div style='width: 100px; height:16px!important; line-height: .45 !important' class='${color}'>
                        ${status ? status !== '' ? status.toUpperCase() : '' : ''}
                    </div>
                </div>`;
  }

  public clear() {
    if (this.requisitionCreateForm.get('patient')?.value) {
      location.replace('/secured/requisitions/create');
    }
  }

  public printRequisition() {
    this.isLoading = true;
    this.reportsService.generateRequisitionReport([this.requisitionCreateForm.get('id')?.value])
      .pipe(take(1))
      .subscribe((blob) => FileUtils.pdfRequestHandler(blob, this));
  }

  public openLabelPrinter() {
    this.printerDialogVisible = true;
  }

  public preventDefault(e: any) {
    e.preventDefault();
  }

  public onButtonReady(e: any) {
    const parent = e.actionElement[0];
    const labelButtons = parent.querySelector('.dx-overlay-content');
    if (labelButtons !== undefined) {
      this.renderer.setStyle(labelButtons, 'overflow', 'visible');
    }
  }

  public onCollectionDateReady(e: any) {
    const element = e.element;
    if (e.component._pickerType === 'native') {
      const button = element.querySelector('.dx-texteditor-buttons-container');
      const input = element.querySelector('.dx-texteditor-input');
      this.renderer.setStyle(button, 'display', 'none');
      this.renderer.setStyle(input, 'padding-right', '5px');
    }
  }

  public openUnsignDialog() {
    this.electronicSignatureUnsignPopupVisible = true;
  }

  public unsignDialogClosed(reset: any) {
    if (reset) {
      this.requisitionCreateForm.get('signature')?.setValue(null);
      if (this.requisitionCreateForm.get('id')?.value) {
        this.requisitionService.unsign(this.requisitionCreateForm.get('id')?.value)
          .pipe(take(1))
          .subscribe(() => {
            if(this.signBtn?.disabled && this.unsignBtn?.disabled) {
              this.signBtn.disabled = false;
              this.unsignBtn.disabled = true;
            }
            this.electronicSignatureUnsignPopupVisible = false;
            notify('Requisition Unsigned!', 'success');
          });
      }
    }
    this.electronicSignatureUnsignPopupVisible = false;
  }

  public signDialogClosed(signatureDialogResponse: SignatureRepresentation) {
    if (signatureDialogResponse) {
      const signature = new MultipleRequisitionsSignature();
      signature.image = signatureDialogResponse.image;
      signature.username = signatureDialogResponse.username;
      signature.requisitionsIds = [this.requisitionCreateForm.get('id')?.value];
      const user = this.fusionAuthService.Profile;
      user.data = {
        signImage: signatureDialogResponse.image,
        clients: user.data !== undefined ? user.data.clients : [],
        patients: user.data !== undefined ? user.data.patients : [],
        physicians: user.data !== undefined ? user.data.physicians : [],
      };
      const request: RegistrationRequest = {
        user,
        registration: {
          applicationId: environment.fusionAuth.applicationId,
          roles: [user.role],
          username: user.username,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      };

      this.fusionAuthManagement
        .updateUser(user.id, request)
        .pipe(take(1))
        .subscribe(response => {
          if (response.status === CREATED) {
            if (this.signBtn?.disabled && this.unsignBtn?.disabled) {
              this.signBtn.disabled = true;
              this.unsignBtn.disabled = false;
            }

            this.requisitionService.signRequisitions(signature)
              .pipe(take(1))
              .subscribe(() => {
                const sign = {
                  signature: {
                    imageSignature: signatureDialogResponse.image,
                    userName: signatureDialogResponse.username,
                    signedDateTime: Date.now(),
                  },
                };
                this.requisitionCreateForm.get('signature')?.setValue(sign);
                this.ref.detectChanges();
                notify('Requisition Signed!', 'success');
              });
          }
        });
    }
    this.electronicSignaturePopupVisible = false;
  }

  public documentClick(name: string) {
    this.isLoading = true;
    this.requisitionService.downloadRequisitionDocuments(this.requisitionId, name)
      .pipe(take(1))
      .subscribe((blob) => FileUtils.pdfRequestHandler(blob, this));
  }

  public documentRemove(id: number) {
    const dialog = custom({
      title: 'Delete Document',
      messageHtml: 'Are you sure you want to remove the document from the requisition?',
      buttons: [{
        text: 'Yes',
        onClick: (e) => {
          return e.component.option('text');
        },
      }, {
        text: 'No',
        onClick: (e) => {
          return e.component.option('text');
        },
      }],
    });

    dialog.show().then((dialogResult: string) => {
      if (dialogResult === 'Yes') {
        this.isLoading = true;
        this.requisitionService.removeRequisitionDocument(this.requisitionId, id)
          .pipe(take(1))
          .subscribe(() => {
            this.requisitionService.getRequisitionDocuments(this.requisitionId).pipe(take(1)).subscribe(docs => this.docs = docs);
            this.isLoading = false;
            dialog.hide();
          });
      } else {
        dialog.hide();
      }
    });

  }

  public onFileChanged(event: Event) {
    const response = FileUtils.validateFile(event as InputEvent, this);
    if (typeof response !== 'boolean') {
      response.then(fileString => {
        // @ts-ignore
        this.requisitionService.uploadDocument(this.requisitionId, fileString, (event.target as HTMLInputElement).files[0].name)
          .pipe(take(1))
          .subscribe(res => {
            this.isUploading = false;
            this.isLoading = false;
            if (res.id) {
              notify('File uploaded successfully', 'success');
              this.requisitionService.getRequisitionDocuments(this.requisitionId).pipe(take(1)).subscribe(docs => this.docs = docs);
            }

          }, () => {
            notify('There was an error uploading your file', 'error');
          });
      });
    }
  }

  public itemClick(e: any) {
    this.buttonGroup?.instance.resetOption('selectedItemKeys');
    this.buttonGroup?.instance.resetOption('selectedItems');
    switch (e.itemData.icon) {
      case 'fa fa-barcode':
        return this.openLabelPrinter();
      case 'fa fa-print':
        return this.printRequisition();
      case 'fa fa-pen-alt': {
        if (!this.signBtn?.disabled) {
          return this.openSignDialog();
        }

        if (!this.unsignBtn?.disabled) {
          return this.openUnsignDialog();
        }

        return;
      }
    }
  }

  public patientSelectionChanged(patient: PatientEditable): void {
    if (patient) {
      this.isLoading = true;
      this.patientService.getPatient(patient.id).pipe(
        take(1),
      )
        .subscribe(p => {
          this.isLoading = false;
          this.selectedClient.next(p.clientId);
          this.ref.detectChanges();
          this.selectedPatientChange.emit(p);
        });
      this.alternateDiagnosisDataSource.next(new DataSource({
        store:
          this.diagnosisService.customStoreFilteredByPatientId(patient.id, this.alternateDiagnosisDataSource),
      }));
      this.alternateMedicationsDataSource.next(new DataSource({
        store:
          this.medicationService.customStoreFilteredByPatientId(patient.id, this.alternateMedicationsDataSource),
      }));
    }
  }

  public billingInfoChanged(patientBillingInfo: BillingInformation[]) {
    const billingInfo = patientBillingInfo.map((bi: BillingInformation) => {
      const temp = new RequisitionBillingInfo();
      temp.position = bi.order ? bi.order : 1;
      temp.patientBillingInformationId = bi.id;
      return temp;
    });
    this.requisitionCreateForm.get('billingInformation')?.setValue(billingInfo);
  }

  private recentRequisition(req: Requisition, patient: PatientEditable, client: string, update: boolean) {
    const requisition = {
      id: req.id,
      birthDate: Moment(patient.birthDate),
      codeValue: req.code,
      clientName: client,
      firstName: patient.firstName,
      lastName: patient.lastName,
      tests: (req.tests ? req.tests : [])
        .filter(t => t.level === 0)
        .map((t: any) => t.test.name)
        .join(', '),
    };
    this.requisitionCreateForm.get('id')?.setValue(requisition.id);

    if (update) {
      this.recentRequisitionService.updateRecentRecentRequisitions(requisition as RecentRequisitionViewModel);
    } else {
      this.recentRequisitionService.addRecentRecentRequisitions(requisition as RecentRequisitionViewModel);
    }


    this.canNavigate = true;
    this.requisitionDoneVisible = true;
  }

  public submit() {
    const requisitionForm = ValidationEngine.validateGroup('requisitionForm');
    if (requisitionForm.isValid && this.requisitionCreateForm.get('tests')?.value !== null
      && this.requisitionCreateForm.get('tests')?.value.length > 0) {
      this.isLoading = true;
      const req = new Requisition();
      req.additionalCopies = this.requisitionCreateForm.get('additionalCopies')?.value;
      req.additionalTestsDxCodes = this.requisitionCreateForm.get('additionalTestsDxCodes')?.value;
      req.patientId = this.requisitionCreateForm.get('patient')?.value.id;
      req.patient = this.requisitionCreateForm.get('patient')?.value;
      req.priority = this.requisitionCreateForm.get('priority')?.value;
      req.collectionDate = new Date(this.requisitionCreateForm.get('collectionDate')?.value).toLocaleString();
      req.comments = this.requisitionCreateForm.get('comments')?.value;
      req.physicianId = this.requisitionCreateForm.get('physician')?.value && this.requisitionCreateForm.get('physician')?.value.id;
      req.fasting = this.requisitionCreateForm.get('fasting')?.value as ClinicalInfo;
      req.tests = TestUtils.generateTestTreeForRequisition(this.requisitionCreateForm.get('tests')?.value);
      req.id = this.requisitionCreateForm.get('id')?.value;

      const selectedBillTo: string = this.requisitionCreateForm.get('billTo')?.value;
      if (selectedBillTo) {
        // @ts-ignore
        req.billTo = BillTo[startCase(selectedBillTo.toLowerCase())];
      }

      const diagnoseIds = this.requisitionCreateForm.get('diagnosisCodes')?.value;
      const medicationIds = this.requisitionCreateForm.get('medications')?.value;
      const billingInfo: RequisitionBillingInfo[] = this.requisitionCreateForm.get('billingInformation')?.value;

      const saveRequest = !this.requisitionCreateForm.get('id')?.value ?
        this.requisitionService.create(req) :
        this.requisitionService.update(req);

      saveRequest
        .pipe(take(1))
        .subscribe(r => {
          forkJoin([
            of(r),
            this.requisitionService.saveMedications(r.id, medicationIds),
            this.requisitionService.saveDiagnoses(r.id, diagnoseIds),
            this.requisitionService.saveBillingInformation(r.id, billingInfo),
          ])
            .subscribe((response) => {
              notify('Requisition Saved!', 'success');
              const patient: PatientEditable = this.requisitionCreateForm.get('patient')?.value;
              const clientName = patient.client.name;
              const wasUpdated = this.requisitionCreateForm.get('id')?.value !== null;
              this.recentRequisition(response[0], patient, clientName, wasUpdated);
              this.isLoading = false;
            });
        });
    } else {
      if (this.requisitionCreateForm.get('patient')?.value === null) {
        notify('A Patient should by selected', 'error', 3000);
      } else if (this.requisitionCreateForm.get('tests')?.value === null || this.requisitionCreateForm.get('tests')?.value.length === 0) {
        notify('At least one test should by selected', 'error', 3000);
      }
    }
  }

  public convertToFormControl(absCtrl: AbstractControl | null): FormControl {
    return absCtrl as FormControl;
  }
}
